import React from 'react';
import { Modal } from '@ann/web-components';

const ModalBase = ({
    title,
    size = "medium",
    width = "666px",
    children,
    isOpen,
    onClose,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size={size} width={width}>
            <Modal.Header>
                <Modal.Header.Title>
                    {title}
                </Modal.Header.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    );
};

export default ModalBase;
